import { useContextSelector } from '@fluentui/react-context-selector';
import { Snackbar, IconButton } from '@material-ui/core';
import { CustomIcon } from 'ams-ui-reactkit';
import React from 'react';
import { StoreContext } from '../../context';
import { actionTypeConstants } from '../../utils';
import { getRandomNumber } from '../../utils/Utils';

/**
 * This is the way to show the sanckbar component from any page
 *       dispatch({
 *           type: actionTypeConstants.SHOW_MESSAGE,
 *           payload: {
 *               id: getRandomNumber(),
 *               show: true,
 *               displayText: "message",
 *               autoHideDuration: 5000
 *           }
 *       });
 */

const SnackMessage = (props:any) => {
    const notification: any = useContextSelector(StoreContext, store => store?.appState?.notifications);
    const dispatch: any = useContextSelector(StoreContext, store => store?.dispatch);

    const handleClose = (notiId: number) => {
        dispatch({
            type: actionTypeConstants.HIDE_MESSAGE,
            payload: {
                id: notiId
            }
        });
    };
    return <React.Fragment>
        {
            notification?.map((item: any, idx: number) => {
                let id = item.id?item.id:getRandomNumber();
                let display = item.display?item.display:props.displayTop
                return <Snackbar
                    key={id}
                    open={item.show}
                    autoHideDuration={props.autoHideDuration}
                    message={item.displayText}
                    onClose={() => handleClose(id)}
                    anchorOrigin={{ vertical: display, horizontal: "right" }}
                    action={
                        <React.Fragment>
                            <IconButton
                                size="small"
                                aria-label="close"
                                color="inherit"
                                onClick={() => handleClose(id)}
                            >
                                <CustomIcon iconName="cancel" size="small" />
                            </IconButton>

                        </React.Fragment>
                    }
                />
            })

        }
    </React.Fragment>

}

SnackMessage.defaultProps = {
    autoHideDuration: 5000,
    displayTop:"top"
};

export default SnackMessage